import { Injectable } from '@angular/core';
export var NgbModalStack = (function () {
    function NgbModalStack() {
    }
    NgbModalStack.prototype.open = function (moduleCFR, contentInjector, content, options) {
        if (options === void 0) { options = {}; }
        if (!this.modalContainer) {
            throw new Error('Missing modal container, add <template ngbModalContainer></template> to one of your application templates.');
        }
        return this.modalContainer.open(moduleCFR, contentInjector, content, options);
    };
    NgbModalStack.prototype.registerContainer = function (modalContainer) { this.modalContainer = modalContainer; };
    NgbModalStack.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    NgbModalStack.ctorParameters = [];
    return NgbModalStack;
}());
//# sourceMappingURL=modal-stack.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ng-bootstrap/ng-bootstrap/modal/modal-stack.js
// module id = 302
// module chunks = 4